import React, { useState, useEffect } from "react";
import * as S from "./ModalSaqueStyle";
// IMPORTANTE: NÃO estamos mais usando o formatNumber global aqui para ter controle total sobre o truncamento
import {
  FaTimes,
  FaMoneyBillWave,
  FaCalendarTimes,
  FaArrowLeft,
  FaSpinner,
} from "react-icons/fa";
import { goldenBoxService } from "../../../Services/goldenBoxService";
import { useMessage } from "../../../context/MessageContext";

// Helper local para formatar truncando (floor)
const formatCurrencyFloor = (value) => {
  if (!value) return "0,00";
  // Trunca para 2 casas decimais sem arredondar pra cima
  const floored = Math.floor(value * 100) / 100;
  return floored.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export default function ModalSaque({ isOpen, onClose, data, onSuccess }) {
  const [step, setStep] = useState(1);
  const [availableBoxes, setAvailableBoxes] = useState([]);
  const [selectedBox, setSelectedBox] = useState(null);
  const [withdrawValue, setWithdrawValue] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const { showMessage } = useMessage();

  console.log(data)
  useEffect(() => {
    if (data && isOpen) {
      const filtered = data.filter((box) => {
        const amount = box.currentAmountAvaliable || 0;
        // CORREÇÃO: Filtra apenas se tiver PELO MENOS 1 centavo REAL (>= 0.01)
        // Usamos uma pequena margem de erro para float precision, mas o conceito é: tem que dar pra sacar 0.01
        return box.isBlocked === false && amount >= 10;
      });
      setAvailableBoxes(filtered);
      setStep(1);
      setSelectedBox(null);
      setWithdrawValue("");
      setError("");
    }
  }, [data, isOpen]);

  const handleSelectBox = (box) => {
    setSelectedBox(box);
    setStep(2);
    setWithdrawValue("");
    setError("");
  };

  const handlePercentage = (percent) => {
    if (!selectedBox) return;
    const max = selectedBox.currentAmountAvaliable || 0;

    let value = max * percent;

    // Garante truncamento para 2 casas decimais
    value = Math.floor(value * 100) / 100;

    setWithdrawValue(value.toFixed(2).replace(".", ","));
    setError("");
  };

  const handleInputChange = (e) => {
    let val = e.target.value;
    val = val.replace(/\./g, ",");

    if (/^\d*,?\d*$/.test(val)) {
      setWithdrawValue(val);
      setError("");
    }
  };

  const handleConfirm = async () => {
    const amountString = withdrawValue.replace(",", ".");
    const amount = parseFloat(amountString);
    const max = selectedBox?.currentAmountAvaliable || 0;

    if (!amount || amount < 10) {
      setError("O valor mínimo para saque é R$ 10,00.");
      return;
    }

    if (amount > max + 0.0001) {
      // Pequena margem para erro de float
      setError("Valor excede o saldo disponível.");
      return;
    }

    try {
      setSubmitting(true);

      await goldenBoxService.requestWithdraw({
        goldenBoxId: selectedBox.id,
        amount: amount,
      });

      showMessage("Saque solicitado com sucesso!", "success");

      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.message || "Erro ao solicitar saque.";
      setError(msg);
      showMessage(msg, "error");
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <S.Overlay onClick={onClose}>
      <S.Container onClick={(e) => e.stopPropagation()}>
        <S.Header>
          <h2>
            <FaMoneyBillWave /> Realizar Saque Golden
          </h2>
          <button onClick={onClose}>
            <FaTimes />
          </button>
        </S.Header>

        <S.Body>
          {availableBoxes.length === 0 && (
            <S.EmptyState>
              <FaCalendarTimes />
              <h3>Nenhum saque disponível hoje</h3>
              <p>
                Não encontramos nenhuma Caixinha Golden com saldo liberado
                (mínimo R$ 10,00) para saque no momento.
                <br />
                Verifique as <strong>Próximas Datas de Saque</strong> clicando
                nos cards das suas caixinhas.
              </p>
            </S.EmptyState>
          )}

          {availableBoxes.length > 0 && step === 1 && (
            <>
              <p
                style={{
                  marginBottom: "15px",
                  color: "#666",
                  fontSize: "14px",
                }}
              >
                Selecione de qual caixinha deseja retirar o saldo:
              </p>
              <S.BoxGrid>
                {availableBoxes.map((box) => (
                  <S.BoxCard key={box.id} onClick={() => handleSelectBox(box)}>
                    <div className="header-card">
                      Contrato #{box.contractId}
                    </div>
                    {/* Usamos a função formatCurrencyFloor aqui para garantir visualização correta */}
                    <div className="value">
                      R$ {formatCurrencyFloor(box.currentAmountAvaliable)}
                    </div>
                    <div className="type">
                      {box.goldenBoxOptionId === 1
                        ? "Saque Anual"
                        : "Saque Fim"}
                    </div>
                  </S.BoxCard>
                ))}
              </S.BoxGrid>
            </>
          )}

          {step === 2 && selectedBox && (
            <S.FormContainer>
              <S.SelectedBoxInfo>
                <p>Saldo Disponível na Caixinha #{selectedBox.id}</p>
                {/* Usamos a função formatCurrencyFloor aqui também */}
                <h3>
                  R$ {formatCurrencyFloor(selectedBox.currentAmountAvaliable)}
                </h3>
              </S.SelectedBoxInfo>

              <S.InputGroup>
                <label>Quanto deseja retirar?</label>
                <S.PercentageButtons>
                  <button onClick={() => handlePercentage(0.5)}>50%</button>
                  <button onClick={() => handlePercentage(1.0)}>
                    100% (Tudo)
                  </button>
                </S.PercentageButtons>

                <div style={{ position: "relative" }}>
                  <span
                    style={{
                      position: "absolute",
                      left: "15px",
                      top: "18px",
                      fontWeight: "bold",
                      color: "#666",
                    }}
                  >
                    R$
                  </span>
                  <input
                    type="text"
                    className="currency-input"
                    value={withdrawValue}
                    onChange={handleInputChange}
                    placeholder="0,00"
                    style={{ paddingLeft: "45px" }}
                  />
                </div>
                {error && <span className="error-msg">{error}</span>}
              </S.InputGroup>
            </S.FormContainer>
          )}
        </S.Body>

        <S.Footer>
          {step === 2 && (
            <S.Button
              className="cancel"
              onClick={() => setStep(1)}
              disabled={submitting}
            >
              <FaArrowLeft /> Voltar
            </S.Button>
          )}

          {availableBoxes.length === 0 ? (
            <S.Button className="cancel" onClick={onClose}>
              Fechar
            </S.Button>
          ) : step === 1 ? (
            <S.Button className="cancel" onClick={onClose}>
              Cancelar
            </S.Button>
          ) : (
            <S.Button
              className="confirm"
              onClick={handleConfirm}
              disabled={submitting}
            >
              {submitting ? (
                <FaSpinner className="fa-spin" />
              ) : (
                "Confirmar Saque"
              )}
            </S.Button>
          )}
        </S.Footer>
      </S.Container>
    </S.Overlay>
  );
}
